
import './App.css';
import { ConfigProvider } from 'antd';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Login from './pages/superadmin/login';
import Home from './pages/superadmin/home';
import CoordinatorLogin from './pages/coordinator/coordinatorlogin';

function App() {

  const theme = {
    token: {
      fontFamily: "'Roboto Condensed', serif !important",
      borderRadius: 6
    },
  };

  return (
    <ConfigProvider theme={theme}>
      <Router>
        <Routes>
          <Route path='/login' element={<Login />}/>
          <Route path='/superadmin/home' element={<Home />}/>
          <Route path='/' element={<CoordinatorLogin />}/>
        </Routes>
      </Router> 
    </ConfigProvider>
  );
}

export default App;
